import { TelemetryLoggerService } from "./logger-service";
import { EventRequest, InternalEventRequest } from "./telemetry-service";
import { TelemetryTemplateService } from "./telemetry-template-svc";
import { TelemetryReadytoSendService } from "../../ServiceDesk/sdServices/telemetry-ready-to-send-service";

export class TelemetryEventPusher {
  // @ngInject
  constructor(
    private telemetryTemplateService: TelemetryTemplateService,
    private loggerService: TelemetryLoggerService,
    private $injector: ng.auto.IInjectorService
  ) {}

  public pushEvent(eventName: string, context: EventRequest, logImmediately?: boolean): any {
    let internalContext = <InternalEventRequest>context;
    let data = {
      name: eventName,
      data: <{ [key: string]: string }>{},
      cV: internalContext.cV || this.loggerService.getCorrelationVector(),
      time: <Date>undefined
    };

    if (context.serviceName) {
      (<any>data).serviceName = context.serviceName;
    }

    let thisPartBEventType = this.telemetryTemplateService.getDefaultPartBTypeForEvent(eventName);
    if (thisPartBEventType) {
      let thisPartB = angular.merge(
        {},
        this.telemetryTemplateService.getDefaultPartBForEvent(eventName),
        internalContext.partB
      );
      data.data[thisPartBEventType] = thisPartB;
    }

    let eventOccurTime = new Date();
    let buildPartC = (time: Date, logImmediately?: boolean) => {
      let thisPartC = angular.merge(
        {},
        this.telemetryTemplateService.getDefaultPartCForEvent(eventName),
        internalContext.partC
      );
      data.data[eventName] = thisPartC;
      data.time = time;
      this.loggerService.pushEvent(data, logImmediately);
    };

    let telemetryReadytoSendService = this.$injector.get<TelemetryReadytoSendService>("telemetryReadytoSendService");
    telemetryReadytoSendService.whenReady().finally(() => buildPartC(eventOccurTime, logImmediately));

    return data;
  }
}
